export class BigWinEvents {
	public static readonly STARTED: string = 'BigWinEvents::__STARTED__';
	public static readonly FINISHED: string = 'BigWinEvents::__FINISHED__';
	public static readonly COUNTUP_STARTED: string = 'BigWinEvents::__COUNTUP_STARTED__';
	public static readonly COUNTUP_FINISHED: string = 'BigWinEvents::__COUNTUP_FINISHED__';

	public static readonly TRANSITION_STARTED: string = 'BigWinEvents::__TRANSITION_STARTED__';
	public static readonly TRANSITION_ENDED: string = 'BigWinEvents::__TRANSITION_ENDED__';

	public static readonly EXPLOSION_STARTED: string = 'BigWinEvents::__EXPLOSION_STARTED__';
	public static readonly BIG_WIN_STARTED: string = 'BigWinEvents::__BIG_WIN_STARTED__';

	public static readonly ON_BEFORE_BIG_WIN: string = 'BigWinEvents::ON_BEFORE_BIG_WIN';
	public static readonly ON_BEFORE_BIG_WIN_FINISHED: string = 'BigWinEvents::ON_BEFORE_BIG_WIN_FINISHED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/bigwin/BigWinEvents.ts